import React from "react";
import { Link } from "react-router-dom";
import { MrFormComponent } from "mr_react_framework";
import { Divider } from "antd";
import "../Login/Login.scss";
import { useDispatch, useSelector } from "react-redux";
import { actions } from "../Login/redux";
import { emailLoadingSelector } from "../Login/selector";
import { useTranslate } from "/src/lib/MrTranslate/MrTranslate";

const getTextCodeLoginForm = (mrIntl) => {
  return {
    processFormData: (dataProps, opts) => {
      console.log("dataProps", dataProps);
      console.log("opts", opts);
      // trim code
      opts.values.code = opts.values.code.trim();
      return opts.values;
    },
    schema: {
      type: "object",
      properties: {
        code: {
          type: "string",
          defaultValue: "",
          placeholder: "Enter code",
          className: "login-code",
          rules: [
            {
              required: true,
              message: mrIntl("TextCodeLogin.please_enter_a_valid_code") || "Please enter a valid code",
            },
          ],
        },
      },
    },
  };
};

const TextCodeLogin = (props) => {
  const dispatch = useDispatch();
  const loading = useSelector(emailLoadingSelector);
  const mrIntl = useTranslate();
  const jsonForm = getTextCodeLoginForm(mrIntl);
  
  const handleSubmit = (data) => {
    // Here you would dispatch an action to verify the text code
    console.log("Text code login submission:", data);
    
    // Example dispatch - replace with actual implementation
    // dispatch(
    //   actions.textCodeLogin(data, {
    //     success: {
    //       showMessage: true,
    //       message: mrIntl("TextCodeLogin.login_successful") || "Login successful",
    //     },
    //   })
    // );
    
    // For now, we'll just redirect to home page after a simulated "success"
    setTimeout(() => {
      window.location.href = "/";
    }, 1000);
  };

  const mainForm = (
    <MrFormComponent
      key={"mrForm"}
      {...props}
      visible={true}
      resourceForm={{
        form: { ...jsonForm },
        config: { isModal: false, visible: true },
      }}
      item={{}}
      loading={loading}
      formConfig={{ 
        actions: { 
          submitText: mrIntl("TextCodeLogin.login") || "Login", 
          showCancelBtn: false 
        } 
      }}
      formProps={{}}
      handleOk={handleSubmit}
      handleSubmit={handleSubmit}
    />
  );

  return (
    <div className={"forgot-pass-main auth-form-container"}>
      <h3>{mrIntl("TextCodeLogin.text_code_login") || "Login with Text Code"}</h3>
      <br></br>
      {mainForm}
      <Divider>{mrIntl("CommonText.or") || "OR"}</Divider>
      <div className={"back-to-login-link"}>
        <Link to={"/auth/login"}>{mrIntl("CommonText.go_back_to_login") || "Go back to login"}</Link>
      </div>
    </div>
  );
};

TextCodeLogin.defaultProps = {};

TextCodeLogin.propTypes = {};

export default TextCodeLogin;